<template>
    <div class="container-fluid">
        <div class="loading-state" v-if="loading">
            <ProgressSpinner fill="transparent" aria-label="Loading" />
        </div>
        <div class="row mb-5">
            <div class="col-12">
                <ul id="dfTab" class="nav nav-tabs" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button id="tab1-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab1" type="button"
                            role="tab" aria-controls="tab1" aria-selected="true" @click="onClickTab('1')">
                            {{ $t("content.gkeeptkhis") }}
                        </button>
                    </li>
                </ul>

                <div id="dfTabContent" class="tab-content">
                    <div id="tab1" class="tab-pane fade" role="tabpanel" aria-labelledby="tab1-tab">
                        <div class="card mt-3">
                            <div class="card-header mb-0">
                                <h5>{{ $t("content.gkeeptkhis") }}</h5>
                            </div>
                            <div class="card-body pt-2">
                                <div class="row">
                                    <div class="col-lg-3 mt-0">
                                        <fieldset>
                                            <div class="item">
                                                <material-checkbox v-model="time_h" :checked="time_h" name="autoSelect"
                                                    @change="onserachDate_h">
                                                    <label class="form-label m-0">{{ $t("content.sdate") }}</label>
                                                </material-checkbox>
                                                <VueDatePicker v-model="start_date" :format="format_h" auto-apply
                                                    :teleport="true" :max-date="new Date().setHours(23, 59, 59)"
                                                    :enable-time-picker="true" month-name-format="long"
                                                    :clearable="false" fluid :disabled="!time_h"
                                                    :text-input="textInputOptions_h" />
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div class="col-lg-3 mt-2">
                                        <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                                        <VueDatePicker v-model="end_date" :format="format_h" auto-apply :teleport="true"
                                            :max-date="new Date().setHours(23, 59, 59)" :enable-time-picker="true"
                                            month-name-format="long" :clearable="false" :text-input="textInputOptions_h"
                                            :disabled="!time_h" fluid />
                                    </div>

                                    <div class="col-lg-4 mt-2">
                                        <label class="form-label ms-0">{{ $t("content.names") }}</label>
                                        <div class="input-group">
                                            <input v-model="cusNameh_search" type="text" class="form-control"
                                                aria-describedby="searchName" readonly />
                                            <button class="btn btn-primary" type="button" @click="openDialogCusH">
                                                <i class="material-icons material-symbols-outlined">search</i>
                                            </button>
                                            <button id="searchNameCus" class="btn btn-primary" type="button"
                                                data-bs-toggle="modal" data-bs-target="#searchNameModal" v-show="false">
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-lg-3">
                                        <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                                        <material-input type="text" v-model="tkh_search" />
                                    </div>
                                    <div class="col-lg-3">
                                        <label class="form-label ms-0">{{ $t("content.gkeepno") }}</label>
                                        <material-input type="text" v-model="tknoh_search" />
                                    </div>
                                    <div class="col-lg-2">
                                        <label class="form-label ms-0">{{ $t("content.type") }}</label>
                                        <select v-model="typetkh_search" class="form-select">
                                            <option value="">{{ $t('content.optall') }}</option>
                                            <option value="DEPOSIT">{{ $t('content.depo') }}</option>
                                            <option value="WITHDRAW">{{ $t('content.withd') }}</option>
                                        </select>
                                    </div>
                                    <div class="col-lg-2">
                                        <label class="form-label ms-0">{{ $t("content.amnchannel") }}</label>
                                        <select v-model="channeltkh_search" class="form-select">
                                            <option value="">{{ $t('content.optall') }}</option>
                                            <option value="SHOP">{{ $t('content.gchshop') }}</option>
                                            <option value="LINE_LIFF">{{ $t('content.gchonline') }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-3 d-flex justify-content-between align-items-center"></div>
                                    <div class="col-9 d-flex justify-content-end align-items-center">
                                        <div class="me-3">
                                            <material-button color="primary" class="float-lg-start float-sm-end mb-3"
                                                :disabled="(!time_h && cusNameh_search === '' && tkh_search === '' && tknoh_search === '') || (time && start_date > end_date)"
                                                @click="loadHistoryListApi">
                                                <i class="material-icons material-symbols-outlined">search</i>
                                                {{ search }}
                                            </material-button>
                                        </div>
                                        <div class="me-3">
                                            <material-button color="danger" class="float-lg-start float-sm-end mb-3"
                                                @click="cancelBtnH">
                                                <i class="material-icons material-symbols-outlined">close</i>
                                                {{ cancel }}
                                            </material-button>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-end align-items-center">
                                        <label class="form-label m-0 me-2">{{ $t("content.expfile") }} :</label>
                                        <div>
                                            <material-button id="pdfBtn" color="info" variant="outline"
                                                class="float-lg-start float-sm-end mb-0 me-2"
                                                :disabled="listhistory.length === 0 || !time_h" @click="pdfHistoryGen">
                                                <i class="material-icons material-symbols-outlined">picture_as_pdf</i>
                                                pdf
                                            </material-button>
                                        </div>
                                    </div>
                                </div>
                                <pre></pre>
                                <div class="row mt-3">
                                    <div class="table-responsive">
                                        <table class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>#</th>
                                                    <th>{{ $t("content.gdpwdtkdate") }}</th>
                                                    <th>{{ $t("content.gkeepno") }}</th>
                                                    <th>{{ $t("content.amnticketold") }}</th>
                                                    <th>{{ $t("content.ticketno") }}</th>
                                                    <th>{{ $t("content.trans") }}</th>
                                                    <th>{{ $t("content.names") }}</th>
                                                    <th>{{ $t("content.gkeepmaker") }}</th>
                                                    <th>{{ $t("content.type") }}</th>
                                                    <th>{{ $t("content.amnchannel") }}</th>
                                                    <th>{{ $t("content.userwittk") }}</th>
                                                    <th>{{ $t("content.amnmaker") }}</th>
                                                    <th>{{ $t("content.act") }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr v-for="(row, index) in listhistory" :key="index">
                                                    <td class="text-sm font-weight-normal">
                                                        {{ formatNumberString((currentPageH - 1) * perPageH + index
                                                            + 1)
                                                        }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ format_datetime(row.createDate) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.refNumber }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.prevTkRefNumber }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.tkRefNumber }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ checkTransaction(row.txType) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.tkCusName }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.cusName }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <span v-if="row.type === 'DEPOSIT'">
                                                            {{ $t("content.stdeposittk") }}
                                                        </span>
                                                        <span v-else>
                                                            {{ $t("content.stwithdrawtk") }}
                                                        </span>
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <span v-if="row.channel === 'SHOP'">
                                                            {{ $t("content.gchshop") }}
                                                        </span>
                                                        <span v-else>
                                                            {{ $t("content.gchonline") }}
                                                        </span>
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.withdrawerName }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.userName }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <material-button color="info" variant="outline"
                                                            class="rounded-circle" :title="t('buttons.seed')"
                                                            @click="openDetail(row.workCaseUid)">
                                                            <i
                                                                class="material-icons material-symbols-outlined">visibility</i>
                                                        </material-button>
                                                        <material-button color="info" variant="outline"
                                                            class="rounded-circle" v-show="false" data-bs-toggle="modal"
                                                            data-bs-target="#lookupModal2" id="detailModal">
                                                        </material-button>
                                                    </td>
                                                </tr>
                                                <tr v-if="listhistory.length === 0">
                                                    <td colspan="12" class="text-sm font-weight-normal">
                                                        <p style="text-align: center">No Record Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colspan="15" style="text-align: right">Total Rows : {{
                                                        totalRows_sH }}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                <pre></pre>
                                <div style="display: flex; justify-content: flex-end">
                                    <ul v-show="listhistory.length > 0" class="pagination justify-content-end">
                                        <div class="project-container">
                                            <div class="example-one">
                                                <vue-awesome-paginate v-model="currentPageH" :total-items="totalRowsH"
                                                    :items-per-page="perPageH" @click="onClickHandlerH" />
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Search Customer Dialog -->
                <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                                    id="closeModal">
                                    <i class="material-icons material-symbols-outlined">close</i>
                                </button>
                            </div>

                            <div class="modal-body">
                                <div class="preview-table">
                                    <section class="panel">
                                        <table class="table table-striped table-responsive">
                                            <thead>
                                                <tr>

                                                    <th>#</th>
                                                    <th>{{ $t("content.cnameth") }}</th>
                                                    <th>{{ $t("content.cnameen") }}</th>
                                                    <th>{{ $t("content.docno") }}</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="row-search">
                                                    <td></td>
                                                    <td>
                                                        <material-input v-model="nameThC" type="text"
                                                            :label="t('content.cnameth')" />
                                                    </td>
                                                    <td>
                                                        <material-input v-model="nameEnC" type="text"
                                                            :label="t('content.cnameen')" />
                                                    </td>
                                                    <td>
                                                        <material-input v-model="docNumberC" type="text"
                                                            :label="t('content.docno')" />
                                                    </td>
                                                    <td>
                                                        <material-button color="primary" variant="contain"
                                                            class="rounded-circle ms-1" data-bs-toggle="tooltip"
                                                            data-bs-placement="top" :title="btnSearch"
                                                            :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                                                            @click="loadCustomerListApi">
                                                            <i
                                                                class="material-icons material-symbols-outlined">search</i>
                                                        </material-button>
                                                    </td>
                                                </tr>
                                                <tr v-for="(row, index) in customerlist" :key="index"
                                                    @click="selectCus(row)">
                                                    <td>{{ formatNumberString((currentPageC - 1) * perPageC + index
                                                        + 1)
                                                    }}</td>
                                                    <td>{{ row.nameTh }}</td>
                                                    <td>{{ row.nameEn }}</td>
                                                    <td colspan="2">{{ row.docNumber }}</td>
                                                </tr>
                                                <tr v-if="customerlist.length === 0">
                                                    <td colspan="5" class="text-sm font-weight-normal">
                                                        <p style="text-align: center">No Record Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </section>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <pre></pre>
                                <div style="display: flex; justify-content: flex-end">
                                    <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                                        <div class="project-container">
                                            <div class="example-one">
                                                <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                                                    :items-per-page="perPageC" @click="onClickHandlerC" />
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Detail Modal -->
                <TicketDetailModal 
                v-if="workcaseDetail !== null"
                :workcaseDetail="workcaseDetail"
                :images="images"
                :listinfo="listinfo"
                :paymentE="paymentE"
                :paymentL="payment_l"
                :promotionDetail="promotionDetail"
                :depRef="dep_ref"
                :tkStatus="tk_status"
                :intCal="int_cal"
                :intPeriod="int_period"
                :transactionLabel="checkTransaction(workcaseDetail.transactionType)"
                :history="'no'" 
                v-model:fcusdt="fcusdt" 
                :afChangename=af_changename
                :bfChangename=bf_changename
                :transDatePrv=transdate_prv
                @copy="copyBtn"
                @openHistory="NewTab"/>



            </div>
        </div>
    </div>
</template>
<script setup>
/* eslint-disable no-unused-vars */
import ProgressSpinner from 'primevue/progressspinner';
import { reactive, ref, computed, onMounted, inject, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ExampleFive from "@/examples/ExampleOne";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import TicketDetailModal from '@/components/TicketDetailModal.vue';
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import Modal from 'bootstrap/js/dist/modal';



import axios from "axios";
import * as st from "@/config/setting.js";
import moment from 'moment'
import noImg from "@/assets/img/noimg.png"
import nofinger from "@/assets/img/noimg.png"

import { useCustomerStore } from '@/stores/customer'
import { useWorkCaseStore } from '@/stores/workcase'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useDepositStore } from '@/stores/deposit'
import { useShopStore } from '@/stores/shop'
import { useDocumentStore } from '@/stores/document'



const storecus = useCustomerStore()
const storewc = useWorkCaseStore()
const storei = useInterestStore()
const storepay = usePaymentGroupStore()
const storedepo = useDepositStore()
const storesh = useShopStore()
const stored = useDocumentStore()




const { t } = useI18n();
const swal = inject("$swal");

const search = computed(() => t("buttons.sear"));
const cancel = computed(() => t("buttons.canc"));
const confirm = computed(() => t("buttons.conf"));
const startscan = computed(() => t("buttons.sscan"));
const newscan = computed(() => t("buttons.nscan"));


const start_date = ref(new Date(new Date().setHours(0, 0, 0)));
const end_date = ref(new Date(new Date().setHours(23, 59, 59)));
const time_h = ref(false);
const cusUidh_search = ref('');
const cusNameh_search = ref('');
const tkh_search = ref('');
const tknoh_search = ref('');
const typetkh_search = ref('');
const channeltkh_search = ref('');
const listhistory = ref([]);
const shop_info = ref(null)
const time = ref(false);


const listinfo = ref([]);
const customerlist = ref([])
const workcaseDetail = ref(null);
const int_cal = ref(0);
const tk_status = ref('');
const int_period = ref('');
const dep_ref = ref('');
const promotionDetail = ref(null);
const fcusdt = ref(false)
const bf_changename = ref('');
const af_changename = ref('');
const transdate_prv = ref(null);

const currentPageH = ref(1);
const totalRowsH = ref(1);
const perPageH = ref(30);
const totalRows_sH = ref();

const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')

const images = ref([])
const images_l = ref([])
const payment_l = ref([])
const paymentE = ref('');

const loading = ref(false);

const key = JSON.parse(localStorage.getItem("shop_seleted"));

const format_h = (date) => {
    return moment(String(date)).local().format('DD/MM/YYYY HH:mm');
}

const textInputOptions_h = {
    format: 'dd/MM/yyyy HH:mm'
};


const onClickHandlerH = () => {
    updatePaginationH()
};


const onClickHandlerC = () => {
    updatePaginationC()
};


const NewTab = async () => {
    sessionStorage.removeItem('deferWorkcaseUid');
    sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
    if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
        const win = window.open("#/generals/defer_items", "_blank");
        win.focus();
        sessionStorage.removeItem('deferWorkcaseUid');
    }
}

function copyBtn() {
    navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}


const onserachDate_h = () => {
    start_date.value = new Date(new Date().setHours(0, 0, 0));
    end_date.value = new Date(new Date().setHours(23, 59, 59));
};

function cancelBtnH() {
    start_date.value = new Date(new Date().setHours(0, 0, 0));
    end_date.value = new Date(new Date().setHours(23, 59, 59));
    cusUidh_search.value = '';
    cusNameh_search.value = '';
    tkh_search.value = '';
    tknoh_search.value = '';
    typetkh_search.value = '';
    channeltkh_search.value = '';
    listhistory.value = []
    totalRows_sH.value = ''
    currentPageH.value = 1
    time_h.value = false;
}


async function onClickTab(val) {
    if (val === '1') {
        if (listhistory.value.length === 0) {
            if (cusNameh_search.value !== '' || tkh_search.value !== '') {
                // loadDataApi()
            }
        }
        await setfirstTab()
    }
}

function formatNumberString(num) {
    return String(num).replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        "$1,"
    );
}

function formatNumberDecimalString(num) {
    if (num !== null && num !== undefined) {
        num = num.toFixed(2)
    } else {
        num = 0
        num = num.toFixed(2)
    }
    return String(num).replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        "$1,"
    );
}

function format_datetime(value) {
    if (value) {
        return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
    }
}

function format_date(value) {
    if (value) {
        return moment(String(value)).local().format('DD/MM/YYYY')
    }
}

async function loadHistoryListApi() {
    if (cusUidh_search.value !== '' || tkh_search.value !== '' || tknoh_search.value !== '' || typetkh_search.value !== '' || channeltkh_search.value !== '' || time_h.value) {
        currentPageH.value = 1
    }

    let data = "";
    let sd = ''
    let ed = ''
    if (time_h.value) {
        sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
        ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
    }
    data = {
        index: currentPageH.value - 1,
        size: perPageH.value,
        groupUid: key.groupUid,
        shopUid: key.uid,
        fromDate: sd,
        toDate: ed,
        cusUid: cusUidh_search.value,
        refNumber: tknoh_search.value.trim(),
        tkRefNumber: tkh_search.value.trim(),
        type: typetkh_search.value, //DEPOSIT,WITHDRAW
        channel: channeltkh_search.value, //SHOP, LINE_LIFF
    };
    const payload = data;
    // console.log("lh p : " + JSON.stringify(payload));
    const response = await storedepo.historyFetch(payload);
    // console.log("lh r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listhistory.value = response.data.data.list
                totalRowsH.value = response.data.data.ext.total
                totalRows_sH.value = formatNumberString(totalRowsH.value)
            }
        }
    }
}


async function setfirstTab() {
    
    if (document.getElementById("tab1-tab")) {
        document.getElementById("tab1-tab").classList.add('show', 'active')
    }

    if (document.getElementById("tab1")) {
        document.getElementById("tab1").classList.add('show', 'active')
    }
}


async function openDialogCusH() {
    nameThC.value = ''
    nameEnC.value = ''
    docNumberC.value = ''
    cusUidh_search.value = ''
    cusNameh_search.value = ''
    customerlist.value = []
    document.getElementById("searchNameCus").click();
}




async function selectCus(item) {
    cusUidh_search.value = item.uid
    cusNameh_search.value = item.nameTh
    document.getElementById("closeModal").click();
}


async function loadCustomerListApi() {
    currentPageC.value = 1
    let data = "";
    data = {
        index: currentPageC.value - 1,
        size: perPageC.value,
        nameEn: nameEnC.value,
        nameTh: nameThC.value,
        docNumber: docNumberC.value,
        groupUid: key.groupUid,
        shopUid: key.uid

    };

    const payload = data;
    // console.log("payload : " + JSON.stringify(payload));
    const response = await storecus.searchCustomerFetch(payload);
    // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                let listd = response.data.data.list;
                customerlist.value = listd;
                totalRowsC.value = response.data.data.ext.total
                totalRows_sC.value = formatNumberString(totalRowsC.value)
            }
        }
    }
}

async function updatePaginationH() {
    listhistory.value = []
    let data = "";
    let sd = ''
    let ed = ''
    if (time_h.value) {
        sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
        ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
    }
    data = {
        index: currentPageH.value - 1,
        size: perPageH.value,
        groupUid: key.groupUid,
        shopUid: key.uid,
        fromDate: sd,
        toDate: ed,
        cusUid: cusUidh_search.value,
        refNumber: tknoh_search.value.trim(),
        tkRefNumber: tkh_search.value.trim(),
        type: typetkh_search.value, //DEPOSIT,WITHDRAW
        channel: channeltkh_search.value, //SHOP, LINE_LIFF
    };
    const payload = data;
    // console.log("lh p : " + JSON.stringify(payload));
    const response = await storedepo.historyFetch(payload);
    // console.log("lh r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listhistory.value = response.data.data.list
                totalRowsH.value = response.data.data.ext.total
                totalRows_sH.value = formatNumberString(totalRowsH.value)
            }
        }
    }

}


async function updatePaginationC() {
    customerlist.value = []
    let data = "";
    data = {
        index: currentPageC.value - 1,
        size: perPageC.value,
        nameEn: nameEnC.value,
        nameTh: nameThC.value,
        docNumber: docNumberC.value,
        groupUid: key.groupUid,
        shopUid: key.uid

    };
    const payload = data;
    // console.log("payload : " + JSON.stringify(payload));
    const response = await storecus.searchCustomerFetch(payload);
    // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                customerlist.value = response.data.data.list;
                totalRowsC.value = response.data.data.ext.total
                totalRows_sC.value = formatNumberString(totalRowsC.value)
            }
        }
    }
}


async function openDetail(wcUid) {
    // console.log('openDetail : ' + JSON.stringify(item));
    workcaseDetail.value = null
    images.value = []
    images_l.value = []
    listinfo.value = []
    tk_status.value = ''
    int_cal.value = 0
    paymentE.value = ''
    int_period.value = ''
    fcusdt.value = false
    dep_ref.value = ''
    bf_changename.value = ''
    af_changename.value = ''
    transdate_prv.value = null
    promotionDetail.value = null

    await getworkCaseInfo(wcUid)
    if (workcaseDetail.value != null) {
        // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
        if (workcaseDetail.value.changeName ) {
              af_changename.value = workcaseDetail.value.tkCustomerInfo.name
              getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
            }else { 
              if (workcaseDetail.value.transactionType !== 'PAWN') { 
                  getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
              }
            }
        
            if (workcaseDetail.value.deposit) {
              getDepositInfo(workcaseDetail.value.tkRefNumber)
            }
            detailPayment(workcaseDetail.value.paymentGroupUid)
        
            images_l.value = workcaseDetail.value.ticket.images
            listinfo.value = workcaseDetail.value.ticket.collaterals
        
            if (workcaseDetail.value.promotionUid !== '0') { 
                  retrieveInfo(workcaseDetail.value)
            }
        
            if (workcaseDetail.value.transactionType !== 'REDEEM') {
              if(workcaseDetail.value.latest){
                calIntInt()
              }
              if (workcaseDetail.value.status === 'FINISH') {
                tk_status.value = 'ปกติ'
              } else if (workcaseDetail.value.status === 'FREEZE') {
                tk_status.value = 'อายัด'
              } else if (workcaseDetail.value.status === 'TERMINATE') {
                tk_status.value = 'ยกเลิก'
              } else if (workcaseDetail.value.status === 'ACTIVE') {
                tk_status.value = 'กำลังดำเนินการ'
              } else if (workcaseDetail.value.status === 'BREAKING') {
                tk_status.value = 'ของหลุด'
              }
        
            } else {
              if (workcaseDetail.value.status === 'FINISH') {
                tk_status.value = 'ไถ่ถอน'
              } else if (workcaseDetail.value.status === 'TERMINATE') {
                tk_status.value = 'ยกเลิก'
              }
            }
            if (images_l.value.length > 0) {
              getTicketImage()
              await nextTick();
              document.getElementById("detailModal").click();
            } else {
              let obj = {
                src: noImg,
                thumbnailImageSrc: noImg,
                alt: '',
                title: ''
              }
              images.value.push(obj)
              await nextTick();
              document.getElementById("detailModal").click();
        
            }
    }
}

async function getTicketImage() {
  images.value = []
  for (let i = 0; i < images_l.value.length; i++) {
    if (images_l.value[i].imageUid !== "0") {
      await getFileImg(images_l.value[i].imageUid, images_l.value[i].uid)
    }
  }
  if (images.value.length > 0) {
    // await nextTick();
    // document.getElementById("detailModal").click();
    loading.value = false
  } else {
    let obj = {
      src: noImg,
      thumbnailImageSrc: noImg,
      alt: '',
      title: ''
    }
    images.value.push(obj)
    // await nextTick();
    // document.getElementById("detailModal").click();
    loading.value = false
  }
}

async function getFileImg(imageUid, uid) {
  let data = "";
  data = {
    shopUid: key.uid,
    uid: imageUid,
  };
  const payload = data;
  // console.log('fi p : ' + JSON.stringify(payload));
  const response = await stored.imgAdminInfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('fi r : ' + JSON.stringify(response.data));
        const file = getFileFromBase64(response.data.data.data, response.data.data.name)
        const data = URL.createObjectURL(file);
        let obj = {
          src: data,
          thumbnailImageSrc: data,
          alt: '',
          title: file.type,
          uid: uid,
          imageUid: imageUid,
        }
        images.value.push(obj)
      }
    }
  }
}

function getFileFromBase64(string64, fileName) {
    const trimmedString = string64.replace('dataimage/jpegbase64', '');
    // const trimmedString = string64;
    const imageContent = atob(trimmedString);
    const buffer = new ArrayBuffer(imageContent.length);
    const view = new Uint8Array(buffer);

    for (let n = 0; n < imageContent.length; n++) {
        view[n] = imageContent.charCodeAt(n);
    }
    var ext = fileName.split('.').pop();
    let type = '';
    if (ext === 'jpg') {
        type = 'image/jpeg'
    } else if (ext === 'png') {
        type = 'image/png'
    }
    const blob = new Blob([buffer], { type });
    return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}

async function getworkCaseInfo(id) {
    let data = "";
    data = {
      uid: id,
      groupUid:key.groupUid,
      shopUid: key.uid,
  };
    const payload = data;

    const response = await storewc.workCaseinfoAdminFetch(payload);
    // console.log("workCaseInfo : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                workcaseDetail.value = response.data.data
            }
        }
    }
}


async function calIntInt() {
    let postponeDate = ''
    if (workcaseDetail.value.postponeCount != 0) {
        postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
    }
    let data = "";
    let pawnValue = 0
    if (workcaseDetail.value.transactionType != 'REDEEM') {
        pawnValue = workcaseDetail.value.newPawnValue
    } else {
        pawnValue = workcaseDetail.value.pawnValue
    }
    data = {
        pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
        previousTxDate: '',
        postponeDate: postponeDate,
        pawnValue: pawnValue,
        promotionUid: workcaseDetail.value.promotionUid,
        interestUid: workcaseDetail.value.interestUid,
    };
    const payload = data;
    // console.log("calIntInt p : " + JSON.stringify(payload));
    const response = await storei.interestCalculateFetch(payload);
    // console.log("calIntInt r : " + JSON.stringify(response.data));
    let res = ''
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                res = response.data.data
                int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
                int_period.value = res.interestPeriod

            }
        }
    }
}

async function detailPayment(item) {
  // console.log('detailPayment : ' + item);
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    uid: item,
  };
  const payload = data;
  const response = await storepay.paymentGroupInfoAdminFetch(payload);
  // console.log("detailPayment : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}

function checkTransaction(str) {
    // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
    let side = ''
    if (str === 'PAWN') {
        side = 'จำนำ'
    } else if (str === 'INTEREST') {
        side = 'ต่อดอกเบี้ย'
    } else if (str === 'REDEEM') {
        side = 'ไถ่ถอน'
    } else if (str === 'INC_PRINCIPLE') {
        side = 'เพิ่มต้น'
    } else if (str === 'DEC_PRINCIPLE') {
        side = 'ลดต้น'
    }
    return side
}

function filterPayType() {
    payment_l.value = []
    let pt = [{ name: 'CASH' },
    { name: 'BANK_TRANSFER' },
    { name: 'CREDIT_CARD' },
    { name: 'CHEQUE' },
    { name: 'PROMPT_PAY_MOBILE' },
    { name: 'PROMPT_PAY_TAX_ID' },
    { name: 'QR_CODE' },
    ]
    let lsum = []
    for (let i = 0; i < pt.length; i++) {
        lsum = filterSumPay(pt[i].name)
        if (lsum.length > 0) {
            payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
        } else {
            payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
        }
    }
}

function filterSumPay(str) {
    let nump = 0, numr = 0, numf = 0
    let lp = paymentE.value.payments.filter((c) => c.type === str);
    if (lp.length > 0) {
        let pay = 0
        let receive = 0
        let fee = 0
        for (let i = 0; i < lp.length; i++) {
            pay = pay + lp[i].pay
            receive = receive + lp[i].receive
            fee = fee + lp[i].feeReceive
            // fee = fee + lp[i].fee
        }
        nump = pay
        numr = receive
        numf = fee
    }
    let lockL = []
    lockL.push({ pay: nump, receive: numr, fee: numf })
    // console.log('lockL : ' + JSON.stringify(lockL));
    return lockL
}


async function getShopInfo() {
    shop_info.value = null
    let data = "";
    data = {
        uid: key.uid,
    };
    const payload = data;
    const response = await storesh.shopInfoFetch(payload);
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                shop_info.value = response.data.data
                // console.log('shop_info : ' + JSON.stringify(shop_info.value));
            }
        }
    }
}


async function pdfHistoryGen() {
    loading.value = true
    if (shop_info.value === null) {
        await getShopInfo()
    }
    let data = "";
    data = {
        page: {
            index: "0",
            size: "0", // size=0 (default) = no page limit
            sort: ""
        },
        filter: {
            groupUid: key.groupUid,
            shopUid: key.uid,
            fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss'),
            toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59'),
            cusUid: cusUidh_search.value,
            refNumber: tknoh_search.value.trim(),
            tkRefNumber: tkh_search.value.trim(),
            type: typetkh_search.value, //DEPOSIT,WITHDRAW
            channel: channeltkh_search.value, //SHOP, LINE_LIFF
            shopName: shop_info.value.fullname,
        }
    };
    // console.log('data : ' + JSON.stringify(data));
    const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
    const accessToken = keya.accessToken;
    const response = await axios({
        method: 'POST',
        data: data,
        url: st.url_api + `/pawn-rpt-svc/deposit/history/pdf`,
        headers: { Authorization: `Bearer ${accessToken}` },
        responseType: 'arraybuffer',
    });
    loading.value = false
    // console.log('pdfGen : ' + JSON.stringify(response.headers.get("content-type")));
    if (response.headers.get("content-type") === 'application/pdf') {

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank').focus();
    } else {
        swal("โหลด PDF ไม่สำเร็จ", "", "error");
    }
}



async function getDepositInfo(tkRef) {
    let data = "";
    data = {
        index: 0,
        size: 1,
        groupUid: key.groupUid,
        shopUid: key.uid,
        cusUid: '',
        refNumber: '',
        tkRefNumber: tkRef.trim(),
        channel: '',
        txDate: 0,
    };
    const payload = data;
    // console.log("ld p : " + JSON.stringify(payload));
    const response = await storedepo.listDepositFetch(payload);
    // console.log("ld r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                let listd = response.data.data.list
                dep_ref.value = listd[0].refNumber
            }
        }
    }
}

async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name
        transdate_prv.value = workcase_prv.workItems[0].startTime 
      }
    }
  }
}

async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }

  let cusUid = item.customerInfo.customerUid

  if(item.represent || item.shopRepresent){
     cusUid =  item.tkCustomerInfo.customerUid 
  }

  data = {
    cusUid : cusUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        const result = res.interests.flatMap(item => {
        // เงื่อนไข: เป็นโปรโมชัน และ periodMonths > 1
        if (item.promotion === true && item.periodMonths > 1) {
          // สร้าง Array ใหม่ที่มีจำนวน element เท่ากับ periodMonths และใส่ข้อมูล item ลงไป
          return Array.from({ length: item.periodMonths }, () => ({ ...item }));
        }
        // หากไม่ตรงเงื่อนไข ให้คืนค่าเดิมกลับไป 1 ชุด
        return [item];
        });
        // console.log('result : ' + JSON.stringify(result));
      res.interests  =  result
      promotionDetail.value = res
      // console.log('promotionDetail : ' + JSON.stringify(promotionDetail.value));
      }
    }
  }
}

onMounted(() => {
    if (document.getElementById("tab1-tab")) {
        document.getElementById("tab1-tab").classList.add('show', 'active')
    }

    if (document.getElementById("tab1")) {
        document.getElementById("tab1").classList.add('show', 'active')
    }
});


</script>
<style lang="scss" scoped>
.inline-icon {
    display: inline-flex;
    vertical-align: top;
    font-size: 20px !important;
}

.loading-state {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.grid-container {
    max-width: 990px;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
}

.btnClose {
    border-color: transparent !important;
    background-color: white !important;
    vertical-align: baseline;

    i.material-icons {
        padding-top: 8px;
        color: gray-600;
    }
}

.grid-containerP {
    max-width: 990px;
    display: grid;
    grid-gap: 1px;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.wrapper {
    position: relative;
}

.myLayer {
    position: absolute;
    /* becomes a layer */
    // left: 0;
    /* relative to its parent wrapper */
    top: -18px;
    right: -23px;
    /* relative to its parent wrapper */
    z-index: 2;
    font-size: 20px;
}

.fs-14 {
  font-size: 0.875rem;
}

.fs-12 {
  font-size: 0.75rem;
}

</style>